<div class="dz-text-16-bold" dcrHTMLKey="PORTFOLIO_SELECTION_PARTNER_TEXT" [dcrSubstitutions]="{ $partnerName$: partnerPlatformControlsList?.[selectedPartner?.id]?.displayName}">
	Platform: $partnerName$
</div>
<p
	class="dz-text-14 padding-top-layout-1 padding-bottom-layout-2"
	dcrHTMLKey="PORTFOLIO_SELECTION_SUB_TEXT"
	[dcrSubstitutions]="{ $maxPortfolios$: digitToWordMapping[maxLimit] + (maxLimit === 1 ? ' portfolio' : ' portfolios') }"
>
	Search for the portfolios you would like to import. Select up to $maxPortfolios$ at a time.
</p>
<form (ngSubmit)="onSearchClick()">
	<div class="search-container" *ngIf="selectedSearchCriteria">
		<dz-select class="search-options" *ngIf="showSearchOptions" [label]="'Search Criteria' | dcr : 'SEARCH_CRITERIA_LABEL'" [(value)]="selectedSearchCriteria">
			<ng-container *ngFor="let criteria of searchCriteria">
				<dz-option [value]="criteria">
					{{ criteria?.displayName }}
				</dz-option>
			</ng-container>
		</dz-select>
		<dz-search
			[isExpanded]="true"
			[placeholder]="selectedSearchCriteria?.placeholder"
			(searchFilterValueChange)="onSearchFilterValueChange($event)"
			class="search-box"
			[class]="showSearchOptions ? 'padding-top-layout-3 padding-left-layout-2' : 'options-hidden'"
		></dz-search>
		<dz-icon
			type="info-circle"
			class="info-circle color-blk-purple dz-text-14 padding-right-object-2 search-icon"
			[tooltip-dcr]="'PARTNER_PORTFOLIO_SEARCH_TOOLTIP_' + selectedPartner?.id"
		></dz-icon>
		<button
			dz-small-button
			class="search-button"
			[disabled]="!searchText"
			dcrHTMLKey="PARTNER_PORTFOLIO_SEARCH"
			custom-tracking
			[track-event]="'import-external-portfolio-search:' + selectedSearchCriteria?.searchCriteriaIds.join()"
		>
			Search
		</button>
	</div>
</form>

<div class="search-hint-text" [dcrHTMLKey]="['IMPORT_PORTFOLIO_SELECTION_SEARCH_HINT_TEXT_' + selectedPartner?.id, 'IMPORT_PORTFOLIO_SELECTION_SEARCH_HINT_TEXT']">
	Use your platform’s wildcard character (e.g. */$) in the search text to locate portfolios or account IDs.
</div>

<div>
	<ng-container *ngIf="isSearching">
		<portfolio-table-skeleton [showTitle]="!!selectedPortfoliosPills?.length"></portfolio-table-skeleton>
	</ng-container>
</div>

<ng-container *ngIf="!isSearching">
	<div>
		<dz-pills [selectedItems]="selectedPortfoliosPills" [showDeselectAll]="true" (pillsChangedEvent)="onPillsChanged($event)"></dz-pills>
	</div>

	<div>
		<ng-container>
			<dz-table [stickyHeaders]="true" [tableHeaders]="tableHeaders">
				<ng-container *ngIf="resultsFound">
					<tr dz-row *ngFor="let row of searchResultRows; let i = index" [ngClass]="{ 'row-disabled': isRowDisabled(row) }">
						<td
							dz-cell
							[ngClass]="{ 'portfolio-name-cell': index === 0 }"
							*ngFor="let column of partnerPlatformControlsList[selectedPartner?.id].searchResultsTableColumnDefs; let index = index"
						>
							<dz-checkbox
								*ngIf="index === 0"
								[value]="row.portfolio.id"
								[disabled]="isRowDisabled(row)"
								(change)="onPortfolioSelected($event)"
								[(ngModel)]="row.isChecked"
							>
							</dz-checkbox>
							{{ row.partnerData[column.id] }}
						</td>
					</tr>
				</ng-container>
			</dz-table>
			<div *ngIf="!resultsFound" class="dz-flex dz-align-items-center margin-top-layout-2 portfolio-search-no-results">
				<dz-pictogram name="portfolio" size="large"></dz-pictogram>
				<div class="margin-top-layout-1" dcrHTMLKey="PORTFOLIO_SELECTION_NO_RESULTS">Your search did not return any results. Please try again.</div>
			</div>
		</ng-container>
	</div>
</ng-container>
